import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { RequestMethodTypes } from '../../../shared/enum/general-enum';

@Injectable()
export class HttpClientService {


  constructor(private httpClient: HttpClient,) {

  }

  /**
   * Sends a GET request.
   *
   * @param url
   * @returns {Observable<T>}
   */
  public get<T>(url): Observable<T> {
    return this.httpClient.get<T>(url);
  }

  /**
   * Sends a POST request.
   *
   * @param url
   * @param data   
   * @returns {Observable<T>}
   */
  public post<T>(url, data): Observable<T> {
    return this.httpClient.post<T>(url, data);
  }

  /**
  * Sends a PUT request.
  *
  * @param url
  * @param data   
  * @returns {Observable<T>}
  */
  public put<T>(url, data): Observable<T> {
    return this.httpClient.put<T>(url, data);
  }

  /**
   * Sends a DELETE request.
   *
   * @param url
   * @returns {Observable<T>}
   */
  public delete<T>(url): Observable<T> {
    return this.httpClient.delete<T>(url);
  }

  /**
   * Uploads a file.
   *
   * @param url
   * @param files
   * @param shouldRename
   * @returns {Observable<T>}
   */
  public uploadFiles<T>(url: string, files: FileList, shouldRename: boolean = false): Observable<T> {
    
    const formData = new FormData();
    for (let i = 0; i < files.length; i = i + 1) {
      let fileName = files[i].name;

      if (shouldRename) {
        const nameFragments = files[0].name.split('.');
        const extension = nameFragments.pop();
        fileName = `${_.kebabCase(nameFragments.join('-'))}.${extension}`;
      }

      formData.append('file', files[i], fileName);
    }
    

    // This does not work.
    // It generates a comma with a space in front of the Content-Type which makes it an invalid Content-Type.
    // headers.append('Content-Type', undefined);

    return this.post<T>(url, formData);
  }

  /**
     * Posts form data.
     * This is useful when performing a POST request which includes files in the request.
     *
     * @param {string} url
     * @param {FormData} formData
     * @returns {Observable<T>}
     */
  public postFormData<T>(url: string, formData: FormData): Observable<T> {
    // const headers = new Headers();
    // this.createAuthorizationHeader(headers);
    // headers['Content-Type'] = undefined;

    return this.post<T>(url, formData);
  }
}


